import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=1f106fad"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"
import style0 from "./Customer.vue?vue&type=style&index=0&id=1f106fad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports